import { useTheme } from "@emotion/react";
import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

// Tooltip reutilizável dos gráficos de linha (latência / perda de pacotes).
// O recharts injeta active/payload/label ao receber este componente como elemento.
export default function ChartTooltip({
  active,
  payload,
  title = "",
  formatValue = (value) => value,
}) {
  const theme = useTheme();

  if (!active || !payload || payload.length === 0) return null;

  const { clock, value } = payload[0].payload;

  const colorKey = value > 80 ? "red" : value <= 80 && value > 40 ? "yellow" : "green";
  const color = theme.palette.cardGraphic.graphColor[colorKey];

  return (
    <Box
      sx={{
        bgcolor: theme.palette.paletteCharts.lineCharts,
        padding: "8px",
        borderRadius: "8px",
      }}
    >
      <Typography fontSize={"14px"}>
        {`Data: ${dayjs.unix(clock).format("DD/MM/YY HH:mm")}`}
      </Typography>

      <Stack direction={"row"} alignItems={"center"} gap={"4px"}>
        <Box
          sx={{
            bgcolor: color,
            width: "14px",
            height: "14px",
            borderRadius: "2px",
            border: `1px solid ${color}`,
          }}
        />
        <Typography fontSize={"14px"}>
          {title}: {formatValue(value)}
        </Typography>
      </Stack>
    </Box>
  );
}
